import React from "react";
import { Button, Checkbox, Control } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {createSetDataFreshAction, createSetDepartmentsDataAction} from "../../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../../state/selectors";



function DepartmentRow(department, endpoint){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);

    const onDelete = () => {
        const url = "api/departments/" + department.department.id;
        const conf = { method: "delete", url };
        axios(conf).then(response =>
            dispatch(createSetDataFreshAction(dataFresh + 1))
        );
    };

    const save = (data) => {
        const url = "api/departments/"+data.id;
        const conf = {method: "put", url, data:data}
        axios(conf). then(response => {
            dispatch(createSetDataFreshAction(dataFresh + 1))
        });
    }
    const onCheck = (e) => {
        let newDepartment = {...department.department};
        newDepartment[e.target.name] = !newDepartment[e.target.name];
        save(newDepartment)
    };
    return (
        <tr>
            <td>{department.department.id}</td>
            <td>{department.department.name}</td>
            <td>
                <Control>
                    <Checkbox
                        type={"checkbox"}
                        name={"hide"}
                        checked={department.department.hide}
                        onChange={(e) => {
                            onCheck(e)
                        }}
                    />
                </Control>
            </td>
            <td>
                <Button
                    color={"danger"}
                    onClick={onDelete}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    );
}
export default DepartmentRow;